import { AccuracyProviderDropdownTypes, ExportProviderAvailabilityType } from "@app/exports/enumerations";
import { ProviderNetworkTypeEnum } from "@app/shared/enums/providerNetworkTypeEnum";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";
import { filter, some } from "lodash";
import { Component } from "react";

interface AccuracySelectProviderFilterProps {
  networkTypes: ProviderNetworkTypeEnum[];
  onProviderFilterTypeChange: (filterType: ProviderNetworkTypeEnum) => void;
  providerFilter: {
    filterType: ProviderNetworkTypeEnum;
    providerAvailabilityType: ExportProviderAvailabilityType;
  };
  providerIds: number[];
}

export default class AccuracySelectProviderFilter extends Component<AccuracySelectProviderFilterProps> {

  private providerTypes = [
    { key: AccuracyProviderDropdownTypes.Network, value: "Network Providers" }
  ];

  public render() {
    const hasProviderIds = this.props.providerIds.length > 0;

    const filteredProviderTypes = Array.from(filter(this.providerTypes, ({ key }) => some(this.props.networkTypes, (nt) => nt.valueOf() === key.valueOf())));
    return (
      <>
        <p className="lead mb0 demibold">Provider Filter{hasProviderIds && <span>: Selected</span>}</p>
        <p>Please select the providers to include:</p>
        <div className="form-group row">
          <div className="col-lg-12 ptb0">
            <QESSelect
              label="Provider Type"
              hideLabel={true}
              testId="accuracy-select-providers-filter"
              disabled={hasProviderIds || this.props.providerFilter.providerAvailabilityType === ExportProviderAvailabilityType.Changed}
              className="form-control"
              value={this.props.providerFilter.filterType}
              onChange={(e) => this.props.onProviderFilterTypeChange(e.target.value as ProviderNetworkTypeEnum)}
            >
              {filteredProviderTypes.map(({ key, value }) => (
                <option key={key} value={key}>{value}</option>
              ))}
            </QESSelect>
          </div>
        </div>
      </>
    );
  }
}
